module.exports = __webpack_public_path__ + "media/images/curve-logo-on-white-0ed2682ccbc150a35f3fd13d6902d04c.jpg";